import { render, staticRenderFns } from "./dividend-pool.vue?vue&type=template&id=4b549f2a&scoped=true&"
import script from "./dividend-pool.vue?vue&type=script&lang=js&"
export * from "./dividend-pool.vue?vue&type=script&lang=js&"
import style0 from "./dividend-pool.vue?vue&type=style&index=0&id=4b549f2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b549f2a",
  null
  
)

export default component.exports